import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Form,
  Input,
  NumberPicker,
  Radio,
  Select,
} from '@alifd/next';
import { DeleteOutlined } from '@ant-design/icons';
import { message, Space, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

import { getAnnouncementType } from '@/helpers/getAnnouncementType';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const PublicInformationSetting = ({ showButton }) => {
  const uploadRef = useRef(null);
  const uploadAnnouncement = useRef(null);
  const announcement = client.service('announcement');
  const uploads = client.service('uploads');
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [userName, setUserName] = useState('');
  const communityData = client.service('communityData');
  const [isUpdate, setIsUpdate] = useState(false);
  const [announcementDialog, setAnnouncementDialog] = useState(false);
  const [announcementObject, setAnnouncementObject] = useState({});
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [disable, setDisable] = useState(true);
  const [uploadAnnouncementPath, setUploadAnnouncementPath] = useState('');
  const [uploadAnnouncementData, setUploadAnnouncementData] = useState(null);
  const [publicFile, setPublFile] = useState({});

  useEffect(() => {
    (async () => {
      const result = await communityData.find({ query: {} });
      setCommunityDataArr(result.data[0]);
      setPublFile(result.data[0].publicFile);
      const userData = await client.reAuthenticate();
      setUserName(userData.user.name);
    })();
  }, [isUpdate, communityData]);
  console.log();

  return (
    <>
      {' '}
      {/* 公共設施參數設定 */}
      <Card free className={styles.publicSetting}>
        <Card.Content>
          <h3>公共設施使用管理辦法</h3>
          <div style={{ marginBottom: 10 }}>
            1.住戶最晚可於預約時間（計時）前
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentHourCancelTimeNum
                  ? communityDataArr.publicAppointmentHourCancelTimeNum
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentHourCancelTimeNum = value;
                setCommunityDataArr(newObject);
              }}
            />
            <Select
              disabled={disable}
              defaultValue="m"
              style={{ marginRight: 8 }}
              value={
                communityDataArr?.publicAppointmentHourCancelTimeUnit
                  ? communityDataArr.publicAppointmentHourCancelTimeUnit
                  : 'm'
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentHourCancelTimeUnit = value;
                setCommunityDataArr(newObject);
                console.log(value);
              }}
            >
              <Select.Option value="m">分鐘</Select.Option>
              <Select.Option value="h">小時</Select.Option>
              <Select.Option value="d">天</Select.Option>
            </Select>
            取消預約，超過時間則不可取消預約。(含住戶推播通知)
          </div>
          <div style={{ marginBottom: 10 }}>
            2.住戶最晚可於營業時間（計次） 前
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentCountCancelTimeNum
                  ? communityDataArr.publicAppointmentCountCancelTimeNum
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentCountCancelTimeNum = value;
                setCommunityDataArr(newObject);
              }}
            />
            <Select
              disabled={disable}
              defaultValue="m"
              style={{ marginRight: 8 }}
              value={
                communityDataArr?.publicAppointmentCountCancelTimeUnit
                  ? communityDataArr.publicAppointmentCountCancelTimeUnit
                  : 'm'
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentCountCancelTimeUnit = value;
                setCommunityDataArr(newObject);
                console.log(value);
              }}
            >
              <Select.Option value="m">分鐘</Select.Option>
              <Select.Option value="h">小時</Select.Option>
              <Select.Option value="d">天</Select.Option>
            </Select>
            取消預約，超過時間則不可取消預約。(含住戶推播通知)
          </div>
          <div style={{ marginBottom: 10 }}>
            3.是否開啟預約後未進入公設自動取消預約功能：{' '}
            <RadioGroup
              disabled={disable}
              value={
                communityDataArr.isLatesTime || communityDataArr.isLatesTime
                  ? 'true'
                  : 'false'
              }
              onChange={(value) => {
                const newValue = value === 'true';
                const newObject = { ...communityDataArr };
                newObject.isLatesTime = newValue;
                setCommunityDataArr(newObject);
              }}
            >
              <Radio value="true">是</Radio>
              <Radio value="false">否</Radio>
            </RadioGroup>
          </div>

          {communityDataArr.isLatesTime && (
            <>
              <div style={{ marginBottom: 10 }}>
                4.住戶最晚可於預約時間（計時）後
                <NumberPicker
                  disabled={disable}
                  min={0}
                  defaultValue={0}
                  value={
                    communityDataArr?.publicAppointmentHourLatestTimeNum
                      ? communityDataArr.publicAppointmentHourLatestTimeNum
                      : 0
                  }
                  onChange={(value) => {
                    const newObject = { ...communityDataArr };
                    newObject.publicAppointmentHourLatestTimeNum = value;
                    setCommunityDataArr(newObject);
                  }}
                />
                <Select
                  disabled={disable}
                  defaultValue="m"
                  style={{ marginRight: 8 }}
                  value={
                    communityDataArr?.publicAppointmentHourLatestTimeUnit
                      ? communityDataArr.publicAppointmentHourLatestTimeUnit
                      : 'm'
                  }
                  onChange={(value) => {
                    const newObject = { ...communityDataArr };
                    newObject.publicAppointmentHourLatestTimeUnit = value;
                    setCommunityDataArr(newObject);
                    console.log(value);
                  }}
                >
                  <Select.Option value="m">分鐘</Select.Option>
                  <Select.Option value="h">小時</Select.Option>
                  <Select.Option value="d">天</Select.Option>
                </Select>
                進入公設，若無進入將取消預約。(含住戶推播通知)
              </div>
            </>
          )}
          <div style={{ marginBottom: 10 }}>
            5.是否開啟逾期自動扣點約功能：{' '}
            <RadioGroup
              disabled={disable}
              value={
                communityDataArr?.isReservationOverdueDeductionPoint
                  ? 'true'
                  : 'false'
              }
              onChange={(value) => {
                const newValue = value === 'true';
                const newObject = { ...communityDataArr };
                newObject.isReservationOverdueDeductionPoint = newValue;
                setCommunityDataArr(newObject);
              }}
            >
              <Radio value="true">是</Radio>
              <Radio value="false">否</Radio>
            </RadioGroup>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Space wrap>
              <Button
                disabled={disable}
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadRef.current.click();
                }}
              >
                {communityDataArr?.publicFile?.name ? '更換檔案' : '檔案上傳'}
              </Button>
              {uploadData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadData.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      setUploadData(null);
                      setUploadPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
              {!uploadData && communityDataArr?.publicFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.publicFile?.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      const newObject = { ...communityDataArr };
                      console.log(newObject);
                      newObject.publicFile = null;
                      setCommunityDataArr(newObject);
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadRef}
              type="file"
              id="upload"
              value={uploadPath || ''}
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadData(file);
                setUploadPath(e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: 10, textAlign: 'right' }}>
            {showButton !== false && disable === true && (
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  setAnnouncementDialog(true);
                  const defaultValue = {
                    title: '更新公共設施管理制度',
                    announcementTime: moment(),
                    content: `1.住戶最晚可於預約時間（計時）前${
                      communityDataArr.publicAppointmentHourCancelTimeNum
                    }${
                      (communityDataArr.publicAppointmentHourCancelTimeUnit ===
                        'm' &&
                        '分鐘') ||
                      (communityDataArr.publicAppointmentHourCancelTimeUnit ===
                        'h' &&
                        '小時') ||
                      (communityDataArr.publicAppointmentHourCancelTimeUnit ===
                        'd' &&
                        '天')
                    }取消預約，超過時間則不可取消預約。\n2.住戶最晚可於營業時間（計次）前${
                      communityDataArr.publicAppointmentCountCancelTimeNum
                    }${
                      (communityDataArr.publicAppointmentCountCancelTimeUnit ===
                        'm' &&
                        '分鐘') ||
                      (communityDataArr.publicAppointmentCountCancelTimeUnit ===
                        'h' &&
                        '小時') ||
                      (communityDataArr.publicAppointmentCountCancelTimeUnit ===
                        'd' &&
                        '天')
                    }取消預約，超過時間則不可取消預約。${
                      communityDataArr.isLatesTime
                        ? `\n3.住戶最晚可於預約時間（計時）後${
                            communityDataArr.publicAppointmentHourLatestTimeNum
                          }${
                            (communityDataArr.publicAppointmentHourLatestTimeUnit ===
                              'm' &&
                              '分鐘') ||
                            (communityDataArr.publicAppointmentHourLatestTimeUnit ===
                              'h' &&
                              '小時') ||
                            (communityDataArr.publicAppointmentHourLatestTimeUnit ===
                              'd' &&
                              '天')
                          }進入公設，若無進入將取消預約。`
                        : ''
                    }`,
                  };
                  setAnnouncementObject(defaultValue);
                  setPublFile(communityDataArr?.publicFile);
                }}
              >
                發佈公告
              </Button>
            )}

            <Button
              type="secondary"
              onClick={async () => {
                setDisable((pre) => !pre);
                console.log(communityDataArr);
                if (disable === false) {
                  try {
                    let NewPublicFile = communityDataArr?.publicFile?.name
                      ? communityDataArr.publicFile
                      : {};
                    if (communityDataArr?.publicFile?.name && uploadData) {
                      await uploads.remove(communityDataArr.publicFile.id);
                    }
                    if (uploadData) {
                      const body = new FormData();
                      body.append('files', uploadData);
                      const res = await fetch(
                        '/newUploads?type=communityData',
                        {
                          method: 'POST',
                          body,
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                        }
                      );
                      const { showPath, _id } = await res.json();
                      NewPublicFile = {
                        path: showPath,
                        name: uploadData.name,
                        id: _id,
                      };
                    }
                    await communityData.patch(communityDataArr._id, {
                      ...communityDataArr,
                      publicFile: NewPublicFile,
                      publicAppointmentCountCancelTime:
                        moment()
                          .startOf('d')
                          .add(
                            communityDataArr.publicAppointmentCountCancelTimeNum,
                            communityDataArr.publicAppointmentCountCancelTimeUnit
                          )
                          .valueOf() - moment().startOf('d').valueOf(),
                      publicAppointmentHourCancelTime:
                        moment()
                          .startOf('d')
                          .add(
                            communityDataArr.publicAppointmentHourCancelTimeNum,
                            communityDataArr.publicAppointmentHourCancelTimeUnit
                          )
                          .valueOf() - moment().startOf('d').valueOf(),
                      publicAppointmentCountLatestTime:
                        moment()
                          .startOf('d')
                          .add(
                            communityDataArr.publicAppointmentCountLatestTimeNum,
                            communityDataArr.publicAppointmentCountLatestTimeUnit
                          )
                          .valueOf() - moment().startOf('d').valueOf(),
                      publicAppointmentHourLatestTime:
                        moment()
                          .startOf('d')
                          .add(
                            communityDataArr.publicAppointmentHourLatestTimeNum,
                            communityDataArr.publicAppointmentHourLatestTimeUnit
                          )
                          .valueOf() - moment().startOf('d').valueOf(),
                    });
                    setIsUpdate((pre) => !pre);
                    message.success('已更新設定參數');
                  } catch (error) {
                    message.error('更新失敗');
                  }
                }
              }}
            >
              {disable === true ? '編輯' : '完成'}
            </Button>
          </div>
        </Card.Content>
      </Card>
      {/* 發佈公告 */}
      <Dialog
        hasMask
        className={styles.announcementDialog}
        visible={announcementDialog}
        onOk={async () => {
          // form1.submit();
          let newAnnounceFile = {};
          if (uploadAnnouncementData) {
            const isImage = uploadAnnouncementData.type.includes('image');
            const body = new FormData();
            body.append('files', uploadAnnouncementData);
            const res = await fetch(
              isImage
                ? '/newUploads?type=announcement'
                : '/newUploads?type=announcement&isConvertPng=true',
              {
                method: 'POST',
                body,
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
              }
            );

            newAnnounceFile = await res.json();
          }
          console.log(newAnnounceFile);

          const announcementType = await getAnnouncementType(newAnnounceFile);

          try {
            const announcementData = {
              ...announcementObject,
              announcementTime: moment(
                announcementObject.announcementObject
              ).valueOf(),
              createdTime: moment().valueOf(),
              updatedTime: moment().valueOf(),
              type: '一般公告',
              fileType: announcementType,
              files:
                Object.keys(newAnnounceFile).length === 0
                  ? []
                  : [
                      {
                        name: publicFile?.name
                          ? publicFile.name
                          : newAnnounceFile.name,
                        response: {
                          ...(publicFile?.name
                            ? {
                                oldName: publicFile.name,
                                showPath: publicFile.path,
                                id: publicFile.id,
                              }
                            : newAnnounceFile[0]),
                        },
                      },
                    ],
              allows: [],
              broadcastStatus: false,
              broadcastGroupId: null,
              calendarStatus: false,
              calendarId: null,
              MessageStatus: false,
              checkedStatus: false,
              announcer: userName,
              endTime: moment().endOf('M').valueOf(),
            };

            announcement.create(announcementData);
            //連動更新communityData
            await communityData.patch(communityDataArr._id, {
              ...communityDataArr,
              publicFile: {
                path: newAnnounceFile.showPath,
                name: newAnnounceFile.oldName,
                id: newAnnounceFile._id,
              },
            });
            setIsUpdate((pre) => !pre);
            setAnnouncementDialog(false);
            message.success('新增成功');
          } catch (error) {
            console.log(error);
          }
        }}
        onCancel={() => {
          setAnnouncementDialog(false);
        }}
        onClose={() => {
          setAnnouncementDialog(false);
        }}
      >
        <Form
          //   form={form1}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          //   onFinish={onFinishAnnouncement}
          autoComplete="off"
        >
          <h3>新增公告</h3>
          <Form.Item
            label="發佈時間"
            name="announcementTime"
            // required
            // requiredMessage="請選擇發佈時間"
          >
            <DatePicker
              showTime={{ format: 'HH:mm:ss' }}
              value={moment(announcementObject.announcementTime)}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.announcementTime = moment(value).valueOf();
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item
            label="標題"
            name="title"
            required
            requiredMessage="請輸入標題"
          >
            <Input
              value={announcementObject.title}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.title = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>

          <Form.Item
            label="內容"
            name="content"
            required
            requiredMessage="請輸入內容"
          >
            <Input.TextArea
              value={announcementObject.content}
              aria-label="TextArea"
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.content = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item label="檔案上傳">
            <Space wrap>
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadAnnouncement.current.click();
                }}
              >
                上傳
              </Button>
              {uploadAnnouncementData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadAnnouncementData.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setUploadAnnouncementPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
              {!uploadAnnouncementData && publicFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.publicFile?.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setUploadAnnouncementPath('');
                      setPublFile({});
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadAnnouncement}
              type="file"
              id="upload"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadAnnouncementData(file);
                setUploadAnnouncementPath(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Dialog>
    </>
  );
};
export default PublicInformationSetting;
